<template>
<div class="myinfo_wrap">
    <div class="page_title_center">
        포인트 내역
    </div>   
    <div class="top_round_deco"></div>
    <div>
        <div class="loading-spinner" v-if="!pointLogs.data">
            <base-spinner></base-spinner>
        </div>
         <!-- 항목 테이블 -->
        <div class="tbl_wrap" v-if="pointLogs.data">
            <table class="tbl">
                <colgroup>               
                <col style="width:*" />                
                <col style="width:15%" />
                </colgroup>
                <thead>
                <tr>                  
                    <th>내역</th>                           
                    <th>날짜</th>                    
                </tr>
                </thead>
                <tbody>
                <template v-if="pointLogs.data.length ===0">
                    <tr><td colspan="2">내역이 없습니다.</td></tr>
                    
                </template>
                    <template v-else>
                        <tr v-for="(log, index) in pointLogs.data" :key="index">                           
                            <td class="article_title txt-left">
                                <div class="title">{{log.act}}</div>
                                <div class="point">
                                    <span>포인트 <strong>{{addComma(log.point,true)}}</strong></span>
                                    / <span> 결과 <strong>{{addComma(log.result_point,true)}}</strong></span>
                                </div>                                
                            </td>                          
                            <td><display-time :time="log.created_at"/></td>
                        </tr>   
                    </template>

                </tbody>
            </table>
            <div class="paginate" ><paginate store="point" collection="pointLogs"  @paging="fetchLists" :isMobile="true"/></div>
        </div>
        <!-- 항목 테이블 -->
    </div>
</div>
</template>
<script>
import { myPoint } from '@/components/mixins/pages/myPoint.js'
export default {
    name:'',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[
        myPoint
    ],
    components:{
        
    },
    mounted() {
    },
    methods:{
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/mobile';
@import '@/assets/scss/table';
.tbl_wrap{
    padding:0;
    .article_title{
        padding-left: 10px;
        div{
            line-height: 30px;
        }
        .title{
            font-weight: bold;
            font-size:14px;
        }
        .point{
            color:#7e7e7e
        }
    }
   
}
</style>